<template>
  <div class="cover">
    <b-container>
      <b-row>
        <b-col>
          <router-link to='/gestion'>
            <div class="button humongous cover"></div>
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'home'
}
</script>

<style lang="scss" scoped>
@import '../styles/common.scss';
</style>
